import Vue from 'vue'
import App from './App.vue'
import { DEVTOOLS_ENABLED } from '@/config/app.config'
import { applyDevToolsLock } from '@/utils/devtoolsLock'

Vue.config.devtools = DEVTOOLS_ENABLED
if (!DEVTOOLS_ENABLED) {
  applyDevToolsLock()
}

// 引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入axios
import { instance } from './request/http'
Vue.prototype.$axios = instance

// 引入路由
import router from "./router/index.js";

Vue.config.productionTip = false

import { getWordPronunciation, getWordPronunciationWithOptions } from '@/utils/publicJs'
Vue.prototype.$getWordPronunciation = getWordPronunciation
Vue.prototype.$getWordPronunciationWithOptions = getWordPronunciationWithOptions

// 引入全局音乐管理器
import musicManager from '@/utils/musicManager'
Vue.prototype.$musicManager = musicManager

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
